module.exports = __webpack_public_path__ + "img/Logout.57e276cb.svg";